export type HttpErrorKind = 'unknown' | 'offline' | 'response';

export interface HttpErrorResponse {
  status?: number;
  result?: any;
}

export interface HttpErrorType extends Error {
  kind: HttpErrorKind;
  response?: HttpErrorResponse;
  /**
   * @deprecated
   */
  getMessage: () => string;
}

export interface HttpErrorConstructor {
  new (kind: HttpErrorKind, message?: string): HttpErrorType;
  readonly prototype: HttpErrorType;
}

export enum Method {
  get = 'GET',
  post = 'POST',
  patch = 'PATCH',
  put = 'PUT',
  delete = 'DELETE',
}

export interface RequesterOptions {
  url: string;
  params: Omit<RequestInit, 'method'> & { method?: Method };
}

export interface RequestOptions<CustomOptions, AdditionalParams> {
  customOptions: CustomOptions;
  url: string;
  params: RequesterOptions['params'] & AdditionalParams;
}

export interface ResponseOptions {
  result?: any;
  status?: number;
  error?: HttpErrorType;
}

export interface RequestOptionsRaw {
  customOptions: any;
  url: string;
  params: any;
}

export interface Requester {
  (options: RequesterOptions): Promise<ResponseOptions>;
}

export interface RequestInterceptor<CustomOptions, AdditionalParams> {
  (input: RequestOptions<CustomOptions, AdditionalParams>): RequestOptions<
    CustomOptions,
    AdditionalParams
  >;
}

export interface ResponseInterceptor<CustomOptions, AdditionalParams> {
  (input: {
    response: ResponseOptions;
    options: RequestOptions<CustomOptions, AdditionalParams>;
  }): ResponseOptions;
}
